import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Tune Vertical"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-tune-vertical',
    templateUrl: './icon-tune-vertical.component.html',
    styleUrls: ['./icon-tune-vertical.component.scss'],
    standalone: false
})
export class IconTuneVerticalComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
